import React, { FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { SeoButton } from 'dibs-seo/exports/SeoButton';
import classnames from 'classnames';

import styles from './HpRespHeroBannerText.scss';

import { HpRespHeroBannerText_heroBannerSettings } from './__generated__/HpRespHeroBannerText_heroBannerSettings.graphql';
import { HpRespHeroBannerText_linkData } from './__generated__/HpRespHeroBannerText_linkData.graphql';

type Props = {
    heroBannerSettings: HpRespHeroBannerText_heroBannerSettings | null;
    linkData: HpRespHeroBannerText_linkData | null;
    cta: string | null;
    onClick: () => void;
    className?: string;
};

const HpRespHeroBannerText: FC<Props> = ({
    heroBannerSettings,
    linkData,
    cta,
    className,
    onClick,
}) => {
    const { textAlignment, contentColor, eyeBrowText, headerText, dekText, ctaStyle } =
        heroBannerSettings || {};

    const textClasses = classnames(className, styles.text, {
        [styles.textAlignCenter]: textAlignment === 'center',
        [styles.contentColorWhite]: contentColor === 'white',
    });

    const ctaClasses = classnames(styles.cta, { [styles.outline]: ctaStyle === 'outline' });

    const linkPath = linkData?.path;

    return (
        <div className={textClasses}>
            <div className={styles.eyeBrow}>{eyeBrowText}</div>
            <div
                className={styles.header}
                dangerouslySetInnerHTML={headerText ? { __html: headerText } : undefined}
            />
            <div className={styles.dek}>{dekText}</div>
            <div>
                {linkPath && cta && (
                    <SeoButton
                        onClick={onClick}
                        dataTn="hero-banner-cta"
                        className={ctaClasses}
                        linkData={linkData || { path: null }}
                        type={ctaStyle === 'outline' ? 'secondary' : 'primary'}
                    >
                        {cta}
                    </SeoButton>
                )}
            </div>
        </div>
    );
};

export default createFragmentContainer(HpRespHeroBannerText, {
    heroBannerSettings: graphql`
        fragment HpRespHeroBannerText_heroBannerSettings on HeroBannerSettingsType {
            textAlignment
            contentColor
            eyeBrowText
            headerText
            dekText
            ctaStyle
        }
    `,
    linkData: graphql`
        fragment HpRespHeroBannerText_linkData on LinkData {
            path
            ...SeoButton_linkData
        }
    `,
});
